import {catchErrorMessage} from "../../../ui-utils/string.utils";
import {MainDashboardLayoutComponent} from "../../../components/main-layout/main.component";
import {PATH_CONSTANT} from "../../../config/path.constant";
import {useReportBAVisitorDetails} from "../../../api/report-ba/visitor/visitor.query.api";
import {useParams} from "react-router-dom";
import {StandartImageComponent} from "../../../components/image/standart-image.component";
import {useMemo} from "react";
import {BounceLoading} from "../../../components/loader/bounce.loading";
import {TableCollapseComponent} from "../../../components/table/table-collaps.component";

const BREAD_CUMB_ITEMS = [
    {
        title: 'Pengunjung',
        path: PATH_CONSTANT.REPORT_BA.VISITOR,
    },
    {
        title: 'Detail Pengunjung',
        path: PATH_CONSTANT.REPORT_BA.VISITOR_DETAIL,
    },
];

export const ReportVisitorDetail = () => {
    const {recordId} = useParams();
    const {data: visitorDetail, isLoading, isError, error} = useReportBAVisitorDetails(recordId);

    const columns = useMemo(
        () => [
            {
                name: 'Product',
                className: 'w-[70%] text-sm font-semibold text-green text-center pr-3',
                dataIndex: 'user',
                render: (record) => (
                    <div className='w-[70%] text-sm font-semibold text-green md:pr-1 pr-3'>
                        <div class='flex items-center pl-2 xl:pl-5'>
                            <div class='w-12'>
                                <StandartImageComponent
                                    src={record?.product_image || '/img/default-product.jpg'}
                                    class='w-12 h-12 object-cover'
                                    alt='Product'
                                />
                            </div>
                            <div className='w-[calc(100%-3rem)] pl-3 xl:pl-5 line-clamp-3'>
                                <div className='block text-xs font-semibold text-dark'>{record?.product_name || '-'}</div>
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                name: 'Produk SKU',
                className:
                    'w-[30%] text-center text-sm font-semibold text-green overflow-hidden text-ellipsis whitespace-nowrap',
                dataIndex: 'product_sku',
                render: (record, product_sku) => (
                    <div class='w-[30%]'>
                        <div class='text-sm text-center font-medium  text-gray'>{product_sku || '-'}</div>
                    </div>
                ),
            },
        ],
        []
    );

    const buyer_columns = useMemo(
        () => [
            {
                name: 'Nama',
                className: 'w-[50%] text-sm font-semibold text-green text-center pr-3',
                dataIndex: 'name',
                render: (record, name) => (
                    <div className='w-[50%] text-sm font-semibold text-green md:pr-1 pr-3'>
                        <div className='block text-center  text-xs font-semibold text-dark'>{record?.name || '-'}</div>
                    </div>
                ),
            },
            {
                name: 'Email',
                className:
                    'w-[30%] text-center text-sm font-semibold text-green overflow-hidden text-ellipsis whitespace-nowrap',
                dataIndex: 'email',
                render: (record, email) => (
                    <div class='w-[30%]'>
                        <div class='text-sm text-center font-medium  text-gray'>{email || '-'}</div>
                    </div>
                ),
            },
            {
                name: 'Phone number',
                className:
                    'w-[30%] text-center text-sm font-semibold text-green overflow-hidden text-ellipsis whitespace-nowrap',
                dataIndex: 'phone',
                render: (record, phone) => (
                    <div class='w-[30%]'>
                        <div class='text-sm text-center font-medium  text-gray'>{phone || '-'}</div>
                    </div>
                ),
            },
        ],
        []
    );

    return (
        <MainDashboardLayoutComponent
            breadCumbs={BREAD_CUMB_ITEMS}
            isError={isError}
            errorTitle={error?.response?.data?.status}
            erroMessage={catchErrorMessage(error?.response?.data?.message)}
        >
            <div className='flex w-full justify-between'>
                <>
                    <div className='w-[calc(100%-290px)]'>
                        <div className='bg-gray-3 mb-5 py-10 px-6'>
                            <div className='flex justify-between items-center pb-10'>
                                <div className={'flex items-center gap-4'}>
                                    <StandartImageComponent
                                        src={visitorDetail?.data?.user?.profile_picture}
                                        class='overflow-hidden rounded-full w-[60px] h-[60px] border-2 border-solid border-green-3'
                                    />
                                    <div className='flex flex-col'>
                                        <div
                                            className='text-sm text-green font-bold mr-3 capitalize'>{visitorDetail?.data?.user?.name}
                                        </div>
                                        <div className='text-sm text-gray font-normal mr-3'>
                                            {visitorDetail?.data?.store?.name}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='flex flex-col text-sm text-gray font-medium'>
                                    <p className={'text-sm text-green font-bold'}>Report Date</p>
                                    {visitorDetail?.data?.store?.report_date_formatted}
                                </div>
                            </div>
                            <div className='border border-solid border-gray-1 flex'>
                                <div className='w-1/3 border-r border-solid border-gray-1 text-center py-2'>
                                    <p className='text-sm text-dark font-semibold'>Jumlah Pengunjung</p>
                                    <p className='text-sm text-gray'>{visitorDetail?.data?.store?.total_visitor}</p>
                                </div>
                                <div className='w-1/3 border-r border-solid border-gray-1 text-center py-2'>
                                    <div className='text-sm text-dark font-semibold'>Jumlah Trialist</div>
                                    <p className='text-sm text-gray'>{visitorDetail?.data?.store?.total_trial}</p>
                                </div>
                                <div className='w-1/3 text-center py-2'>
                                    <div className='text-sm text-dark font-semibold'>Jumlah Pembeli</div>
                                    <p className='text-sm text-gray'>{visitorDetail?.data?.store?.total_buyer}</p>
                                </div>
                            </div>
                            <div className='block text-sm font-semibold text-dark text-center mb-3 mt-6'>Jumlah Trialist</div>
                            <div className='border border-solid border-gray-1 flex'>
                                {visitorDetail?.data?.total_trial_by_brand?.map((brand, index) => (
                                    <div key={index} className='w-1/3 border-r border-solid border-gray-1 text-center py-2'>
                                        <p className='text-sm text-dark font-semibold'>{brand.name}</p>
                                        <p className='text-sm text-gray'>{brand.total || 0}</p>
                                    </div>
                                ))}
                            </div>
                            <div className='block text-sm font-semibold text-dark text-center mb-3 mt-6'>Jumlah Pembeli</div>
                            <div className='border border-solid border-gray-1 flex'>
                                {visitorDetail?.data?.total_buyer_by_brand?.map((brand, index) => (
                                    <div key={index} className='w-1/3 border-r border-solid border-gray-1 text-center py-2'>
                                        <p className='text-sm text-dark font-semibold'>{brand.name}</p>
                                        <p className='text-sm text-gray'>{brand.total || 0}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </>
                <div className='w-[270px]'>
                    <div className='bg-gray-3 py-5 px-4 mb-4'>
                        <div className='block text-sm font-semibold text-dark mb-3'>Catatan</div>
                        <p className='text-gray text-sm mb-4'>{visitorDetail?.data?.store.note || '-'}</p>
                    </div>
                    <div className='bg-gray-3 py-5 px-4'>
                        <div className='block text-sm font-semibold text-dark mb-3'>Bantuan Tim AVO</div>
                        <p className='text-gray text-sm mb-4'>{visitorDetail?.data?.store.helpdesk_avo || '-'}</p>
                    </div>
                </div>
            </div>
            {isLoading ? (
                <div className='h-[70vh] flex items-center'>
                    <BounceLoading color='#5E755A'/>
                </div>
            ) : (
                <div className={'flex flex-col gap-8'}>
                    <div className='w-[calc(100%-290px)]'>
                        <TableCollapseComponent
                            columns={columns}
                            initialOpen
                            data={visitorDetail?.data?.store?.high_demand_products || []}
                            title='Product Kosong dan Banyak di Cari'
                            name='high_demand_products'
                        />
                    </div>
                    <div className='w-[calc(100%-290px)]'>
                        <TableCollapseComponent
                            columns={buyer_columns}
                            initialOpen
                            data={visitorDetail?.data?.buyers || []}
                            title='Informasi Daftar Pembeli'
                            name='buyers'
                        />
                    </div>
                    <div>
                        <div
                            className='flex flex-col w-[calc(100%-290px)] gap-2 mb-3  pl-6 pr-16 py-2.5 bg-gray-3 leading-tight border border-solid border-gray-1 rounded-sm'
                        >
                            <p className={'text-sm text-dark font-semibold'}>Promo Kompetitor</p>
                            <p className="text-sm text-gray-600 whitespace-pre-line">
                                {visitorDetail?.data?.competitor?.promo?.trim() || '-'}
                            </p>
                        </div>
                        <div className='font-semibold text-sm my-4 mx-4'>Visual Promo & Display Kompetitor</div>
                        <div className='flex flex-wrap gap-4 mx-4'>
                            {
                                visitorDetail?.data?.competitor?.displays.length > 0 &&
                                visitorDetail?.data?.competitor?.displays.map((item, index) => (
                                    <div key={index} className='relative'>
                                        <div className={'w-56 h-auto'}>
                                            <StandartImageComponent
                                                defaultImage='/img/image-not-found.png'
                                                src={item?.image_url}
                                                withZoom
                                                alt={`Preview ${index + 1}`}
                                                className='w-56 h-56 object-cover'
                                            />
                                            <div className={'text-[11px] mt-1'}>
                                                <p>Deskripsi :</p>
                                                <p
                                                    className="max-h-12 overflow-hidden text-ellipsis line-clamp-3"
                                                    title={item?.description}
                                                >
                                                    {item?.description || 'No description available'}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            )}
        </MainDashboardLayoutComponent>
    )
}
